import classNames from 'classnames';
import React from 'react';
import './Note.scss';

export interface NoteProps {
  className?: string;
  styleName?: string;
  title?: JSX.Element | string;
}

const Note: React.FC<NoteProps> = ({
  children,
  className = '',
  styleName = '',
  title,
}) => (
  <div className={classNames('note', className, styleName)}>
    <span className="note-title">{title}</span> {children}
  </div>
);

export default Note;
